(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf26-find-your-pilates-plan"] && !Shopify.designMode) return;
  try {
    
(() => {
  function mount(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const panels = [...root.querySelectorAll('[data-step]')];
    const copy = JSON.parse(root.querySelector('[data-sfq-copy]').textContent);
    const progress = root.querySelector('.sfq-progress');
    const back = root.querySelector('[data-back]');
    const storageKey = 'sculpted-flow-quiz-v2';
    let current = 0;
    const selected = name => [...root.querySelectorAll('input[name="' + name + '"]:checked')].map(i => i.value);
    const value = name => selected(name)[0];
    const labels = name => [...root.querySelectorAll('input[name="' + name + '"]:checked')].map(i => i.closest('label').querySelector('.sfq-choice-text').textContent.trim());
    const format = (key, args = {}) => Object.entries(args).reduce((s, [k,v]) => s.replaceAll('{' + k + '}', v), copy[key] || '');
    function persist() {
      try { sessionStorage.setItem(storageKey, JSON.stringify({current, answers:[...root.querySelectorAll('input:checked')].map(i=>[i.name,i.value])})); } catch (_) {}
    }
    function updateDuration() {
      const n = value('time') || '15';
      const display = n;
      root.querySelector('[data-step="duration"] h2').textContent = format('duration_title', {minutes:display});
      root.querySelector('[data-time-label]').textContent = format('time_label', {minutes:display});
      root.querySelector('[data-time-copy]').textContent = copy['time_' + n];
      const chunks = {15:[3,9,3],30:[5,20,5]}[n];
      root.querySelectorAll('[data-phase]').forEach((el,i)=>el.textContent=chunks[i]+' '+copy.minutes_short);
    }
    function renderResult() {
      const lines = [copy['goal_' + value('goal')], format('time_label', {minutes:value('time')}) + '. ' + copy['time_' + value('time')], value('seated') === 'agree' ? copy.format_seated : copy.format_mixed, value('accessories') === 'yes' ? copy.experience_yes : copy.experience_new];
      if (value('guidance') === 'agree') lines.push(copy.guidance_yes);
      if (value('motivation') === 'agree') lines.push(copy.motivation_yes);
      lines.push(value('walk') === 'rarely' || value('stairs') === 'frequent' ? copy.habit_gentle : copy.habit_regular);
      if (value('active') === 'agree') lines.push(copy.active_yes);
      if (value('hub') === 'agree') lines.push(copy.hub_yes);
      lines.push(copy['speed_' + value('speed')]);
      const list = root.querySelector('[data-summary]');
      list.replaceChildren(...lines.filter(Boolean).map(text=>{const li=document.createElement('li');li.textContent=text;return li;}));
      const tags = [copy.age_prefix+labels('age').join(', '),copy.time_prefix+labels('time').join(', '),copy.area_prefix+labels('areas').join(', ')];
      root.querySelector('[data-answer-tags]').replaceChildren(...tags.map(text=>{const span=document.createElement('span');span.textContent=text;return span;}));
      const answerList=root.querySelector('[data-answer-list]');
      answerList.replaceChildren();
      panels.filter(p=>p.hasAttribute('data-question')).forEach(p=>{const dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=copy['question_'+p.dataset.step];dd.textContent=labels(p.dataset.step).join(', ');answerList.append(dt,dd);});
    }
    function show(index, focus=true) {
      current=Math.max(0,Math.min(index,panels.length-1));
      panels.forEach((p,i)=>p.hidden=i!==current);
      back.disabled=current===0;
      const percent=Math.round(current/(panels.length-1)*100);
      progress.setAttribute('aria-valuenow',percent);
      progress.firstElementChild.style.width=percent+'%';
      root.querySelector('[data-step-count]').textContent=format('step',{current:current+1,total:panels.length});
      const active=panels[current],next=active.querySelector('[data-next]');
      if(next) next.disabled=active.hasAttribute('data-question')&&!selected(active.dataset.step).length;
      const concern=selected('joints').some(x=>x!=='none') || value('stairs')==='frequent';
      root.querySelectorAll('[data-concern-note]').forEach(el=>el.hidden=!concern);
      if(active.dataset.step==='duration')updateDuration();
      if(active.dataset.step==='result')renderResult();
      persist();
      if(focus){root.scrollIntoView({block:'start',behavior:'instant'});active.querySelector('h1,h2').focus({preventScroll:true});}
    }
    root.addEventListener('change',e=>{
      if(!e.target.matches('input'))return;
      const input=e.target;
      if(input.name==='joints'&&input.checked){
        root.querySelectorAll('input[name="joints"]').forEach(i=>{if(i!==input&&(input.value==='none'||i.value==='none'))i.checked=false;});
      }
      if(input.type==='radio')show(current+1);
      else{const btn=panels[current].querySelector('[data-next]');btn.disabled=!selected(input.name).length;persist();}
    });
    root.addEventListener('click',e=>{
      const next=e.target.closest('[data-next]');
      if(next&&!next.disabled){const p=panels[current];if(p.hasAttribute('data-question')&&!selected(p.dataset.step).length)return;show(current+1);}
      if(e.target.closest('[data-back]'))show(current-1);
      if(e.target.closest('[data-restart]')){root.querySelectorAll('input').forEach(i=>i.checked=false);try{sessionStorage.removeItem(storageKey);}catch(_){}show(0);}
      const choice=e.target.closest('label');
      if(choice&&e.target.tagName!=='INPUT'){const checked=choice.querySelector('input[type="radio"]:checked');if(checked){e.preventDefault();show(current+1);}}
    });
    try {
      const saved=JSON.parse(sessionStorage.getItem(storageKey));
      if(saved&&Array.isArray(saved.answers)&&Number.isInteger(saved.current)){
        root.querySelectorAll('input').forEach(i=>i.checked=saved.answers.some(a=>a[0]===i.name&&a[1]===i.value));
        current=Math.min(saved.current,panels.length-1);
        for(let i=0;i<current;i++){if(panels[i].hasAttribute('data-question')&&!selected(panels[i].dataset.step).length){current=i;break;}}
      }
    } catch (_) {}
    show(current,false);
  }
  const start=()=>document.querySelectorAll('[data-sfq]').forEach(mount);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',start);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf26-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', function(event) {
  const input = event.target.closest('[data-sf26-color-image]');
  if (!input || !input.checked || !input.dataset.sf26ColorImage) return;
  const product = input.closest('[data-sf26-product]');
  const image = product && product.querySelector('[data-sf26-main-image]');
  if (!image) return;
  image.removeAttribute('srcset');
  image.src = input.dataset.sf26ColorImage;
  image.alt = input.dataset.sf26ColorTitle + ' Pilates Bar Kit with resistance bands';
});

  } catch(e) { console.error(e); }
})();
})();
